import React from 'react';
import { T, fontBody } from './tokens';

export default function ToggleRow({ label, checked, onChange, disabled }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', opacity: disabled ? 0.5 : 1 }}>
      {label && <span style={{ fontFamily: fontBody, fontSize: 13, color: T.ink }}>{label}</span>}
      <button
        type="button"
        disabled={disabled}
        onClick={() => onChange(!checked)}
        style={{
          width: 38, height: 22, borderRadius: 999, border: 'none',
          background: checked ? T.blue : '#E2E5EA', position: 'relative', flexShrink: 0,
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
      >
        <span style={{
          position: 'absolute', top: 2, left: checked ? 18 : 2, width: 18, height: 18, borderRadius: '50%',
          background: '#fff', transition: 'left .15s', boxShadow: '0 1px 2px rgba(0,0,0,0.2)',
        }}
        />
      </button>
    </div>
  );
}
